var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container"},[_c('csml-monaco-editor',{staticClass:"csml-editor",on:{"change":_vm.updateContent,"editorDidMount":_vm.onEditorDidMount,"save":_vm.onSave},model:{value:(_vm.csmlContent),callback:function ($$v) {_vm.csmlContent=$$v},expression:"csmlContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }